import {Component, inject} from '@angular/core';
import {LayoutService} from './services/app.layout.service';
import {LoggerService} from '../shared/services/logger.service';

@Component({
    selector: 'app-footer-component',
    providers: [],
    template: `
      <div class="layout-footer">
        <div class="w-24 pt-5"><app-logo-ddh [dark]="layoutService.isDarkTheme() || false" /></div>
      </div>
    `,
    standalone: false
})
export class AppFooterComponent {
  protected readonly logger = inject(LoggerService);
  layoutService = inject(LayoutService);
}
